import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
  className?: string
}

const sizeClasses = {
  sm: 'size-5',
  md: 'size-8',
  lg: 'size-12',
}

export function Loader({ size = 'md', text, className }: LoaderProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <Loader2 className={cn('text-[#666] animate-spin', sizeClasses[size])} />
      {text && <p className="text-sm text-[#555]">{text}</p>}
    </div>
  )
}
